import viewCustomUnitEn from "./locales/en.json";

export const VIEW_CUSTOM_UNIT_NS = "viewCustomUnit" as const;

export const ViewCustomUnitI18n = {
  en: {
    [VIEW_CUSTOM_UNIT_NS]: {
      ...viewCustomUnitEn,
    },
  },
};
